import { useDispatch } from "react-redux";

import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";

const AdminActionLogListApi = () => {
	const dispatch = useDispatch();
	const url = "/admin/action_log_list";

	const ExecAdminActionLogListApi = async (requestParams) => {
		let response = null;
		let error = null;

		try {
			response = await ApiRequest({ url, requestParams});
		} catch (e) {
			error = e;
		}

		if (response !== null && response.error_code === 0) {
			dispatch(setApiTimestamp(response['now_time']));
		}
		return { response, error };
	};

	return ExecAdminActionLogListApi;
};

export default AdminActionLogListApi;
